import { useMemo } from "react";
import { SwipeableTabs, type SwipeableTabItem } from "@/components/ui/swipeable-tabs";
import DeviceCertificates from "./DeviceCertificates";
import DeviceConfigurations from "./DeviceConfigurations";
import DeploymentHistory from "./DeploymentHistory";
import DeviceAuditLog from "./DeviceAuditLog";
import SystemInformation from "./SystemInformation";
import InstalledApplications from "./InstalledApplications";
import ManagedApplications from "./ManagedApplications";
import DeviceAnalytics from "./DeviceAnalytics";
import DeviceLogs from "./DeviceLogs";
import { type Device } from "@/hooks/useDevices";

interface DeviceTabsProps {
  device: Device;
  activeTab?: string;
  onTabChange?: (value: string) => void;
}

const DeviceTabs = ({ device, activeTab = "info", onTabChange }: DeviceTabsProps) => {
  const items = useMemo<SwipeableTabItem[]>(
    () => [
      { value: "info", label: "System Information", content: <SystemInformation device={device} /> },
      { value: "analytics", label: "Analytics", content: <DeviceAnalytics device={device} /> },
      { value: "apps", label: "Installed Apps", content: <InstalledApplications device={device} /> },
      { value: "managed-apps", label: "Managed Apps", content: <ManagedApplications deviceId={device.id} /> },
      { value: "configs", label: "Configurations", content: <DeviceConfigurations deviceId={device.id} /> },
      { value: "deployments", label: "Deployments", content: <DeploymentHistory deployments={device.script_deployments} /> },
      { value: "certificates", label: "Certificates", content: <DeviceCertificates deviceId={device.id} /> },
      { value: "logs", label: "Device Logs", content: <DeviceLogs deviceId={device.id} /> },
      { value: "audit", label: "Audit Log", content: <DeviceAuditLog device={device} /> },
    ],
    [device],
  );

  return (
    <div className="w-full bg-white dark:bg-slate-800 rounded-lg border">
      <SwipeableTabs
        items={items}
        value={activeTab}
        onValueChange={(v) => onTabChange?.(v)}
      />
    </div>
  );
};

export default DeviceTabs;
